import { Button } from '@/components/ui/button';
import useReservationActions from '@/hooks/useReservationActions';
import { ReservationStatus, TReservationStatus } from '@/utils/reservations';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PresentCheckbox: React.FC<{
  reservationId: string;
  reservarionStatus: TReservationStatus;
}> = ({ reservationId, reservarionStatus }) => {
  const { t } = useTranslation();
  const { handleAbsent, handleCompleted, isPending } = useReservationActions({
    disabledRefetch: true
  });
  const isDisabled =
    reservarionStatus === ReservationStatus.Requested || isPending;
  const isPresent = reservarionStatus === ReservationStatus.Completed;
  const isAbsent = reservarionStatus === ReservationStatus.Absent;

  return (
    <div className="flex flex-col items-center">
      <div className="flex gap-2 items-center pr-4">
        {!isPresent && !isAbsent ? (
          <>
            <Button
              disabled={isDisabled}
              onClick={() =>
                handleCompleted(reservationId, { markAllPresent: true })
              }
            >
              {t('common.status.present').split('')[0]}
            </Button>
            <Button
              variant="destructive"
              disabled={isDisabled}
              onClick={() =>
                handleAbsent(reservationId, { markAllAbsent: true })
              }
            >
              {t('common.status.absent').split('')[0]}
            </Button>
          </>
        ) : isPresent ? (
          <Button
            disabled={isDisabled}
            onClick={() => handleAbsent(reservationId, { markAllAbsent: true })}
          >
            {t('common.status.present')}
          </Button>
        ) : (
          <Button
            variant="destructive"
            disabled={isDisabled}
            onClick={() =>
              handleCompleted(reservationId, { markAllPresent: true })
            }
          >
            {t('common.status.absent')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PresentCheckbox;
